import React from "react";

declare const addCookieBookmark: (
  e: React.MouseEvent,
  articleId?: string
) => void;
declare const deleteCookieBookmark: (
  e: React.MouseEvent,
  articleId?: string
) => void;

type Props = { articleId: string; articleTitle?: string };

function PortalBookmarkButtons({ articleId, articleTitle }: Props) {
  return (
    <div className="portalArticleBoxBookmark jsBookmark" data-id={articleId}>
      {/* NOTE: aria-labelは可視テキストをそのまま含めないと label-content-name-mismatch になるため「可視テキスト（タイトル）」形式 */}
      <button
        type="button"
        className="p_btnLarge isNeutral isAdd"
        aria-label={
          articleTitle ? `お気に入り追加（${articleTitle}）` : undefined
        }
        onClick={(e) => addCookieBookmark(e, articleId)}
      >
        <i className="fa fa-star" aria-hidden="true" />
        お気に入り追加
      </button>
      <button
        type="button"
        className="p_btnLarge isNeutral isRemove"
        aria-label={
          articleTitle ? `お気に入り削除（${articleTitle}）` : undefined
        }
        onClick={(e) => deleteCookieBookmark(e, articleId)}
      >
        <i className="fa fa-times" aria-hidden="true" />
        お気に入り削除
      </button>
    </div>
  );
}

PortalBookmarkButtons.defaultProps = {
  articleTitle: "",
};

export default PortalBookmarkButtons;
